/**
 * 404 page — matches PublicSite's "Astra" 404
 * (client/src/pages/not-found.tsx) so a bad URL reads as on-brand rather
 * than a blank white page. Mounted as a catch-all inside the authenticated
 * <Layout /> route in App.tsx so the sidebar stays visible for deep bad
 * URLs (e.g. /growth-os/scoreboard-typo).
 */
import { Link } from 'react-router-dom';
import astraImage from '@/assets/astra-404.png';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-code">404</h1>
        <p className="not-found-tagline">Astra got to the wires first.</p>
        <p className="not-found-subline">
          This page is offline. The rest of the grid is up.
        </p>
        <img
          src={astraImage}
          alt="Astra the border collie playfully chewing on wires that run off both sides of the screen"
          className="not-found-image"
          draggable={false}
        />
        <Link to="/" className="not-found-cta">
          Reconnect to Home
        </Link>
      </div>
    </div>
  );
}
